/**
 * BEA / RIMS II attribution constants.
 *
 * Any UI surface, export, or report that displays RIMS II multiplier values
 * (or values derived from them — spin-off jobs, earnings, output impact) MUST
 * show BOTH `RIMS_II_ATTRIBUTION` and `RIMS_II_DISCLAIMER` to the end user.
 *
 * Any UI surface or export that displays other BEA API data (NIPA, Regional,
 * GDP-by-Industry, etc.) MUST show `BEA_ATTRIBUTION`.
 *
 * Compliance rules:
 *   - Never use BEA or U.S. Department of Commerce logos, seals, or marks.
 *   - Never use wording that implies BEA or federal endorsement of Develio
 *     or its outputs (e.g. "BEA-certified", "federally validated", etc.).
 *   - Attribution must be visible to the end user — not buried in a tooltip.
 *
 * All attribution strings in the codebase should import from this file. Do
 * not hardcode these strings inline anywhere; the compliance test asserts
 * this is the single source of truth.
 */

export const RIMS_II_ATTRIBUTION =
  'Source: U.S. Bureau of Economic Analysis, Regional Input-Output Modeling System (RIMS II)';

export const RIMS_II_DISCLAIMER =
  'BEA does not endorse any resulting estimates and/or conclusions.';

export const BEA_ATTRIBUTION = 'Source: U.S. Bureau of Economic Analysis';

/**
 * Combined attribution + disclaimer rendered as a single plain-text block.
 * Safe for CSV footers, plain-text exports, and tooltips where markup is
 * not available. UI surfaces should prefer the <BEAAttribution /> React
 * component so styling stays consistent.
 */
export const RIMS_II_ATTRIBUTION_BLOCK = `${RIMS_II_ATTRIBUTION}\n${RIMS_II_DISCLAIMER}`;
